import React from 'react';
import { MenuUser, ResponseGetMenu, ResponseUpdateMenu } from './MenuContainer';
import { Button, CenterManager, LoadingView, Role } from '@cuatroochenta/co-admin-react-library';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import './MenuView.scss';
import { withTranslation, WithTranslation } from 'react-i18next';
import { translate } from '../../../I18n/i18n';
import { Center } from '../../model/domain/center';

interface MenuViewProps extends WithTranslation {
    getMenu: (centerId: number | undefined) => Promise<void>
    getUser: () => Promise<void>
    getCenters: () => Promise<void>
    updateMenu: (centerId: number | undefined, file: File) => Promise<void>
    resetMenu: () => void
    getMenuResponse: ResponseGetMenu | null
    updateMenuResponse: ResponseUpdateMenu | null
    user: MenuUser | null
    centers: Center[] | null
}

interface State {
    centerId: number | undefined
    file: File | null
    loading: boolean
}

class MenuView extends React.Component<MenuViewProps> {

    public state: State = {
        centerId: undefined,
        file: null,
        loading: false
    };

    componentDidMount(): void {
        const storedCenterId = CenterManager.getSelectedCenter();
        console.log("storedCenterId: " + storedCenterId)
        this.setState({ centerId: storedCenterId ? parseInt(storedCenterId) : undefined, loading: true });
        this.props.getUser()
            .then(() => this.setState({loading: false}));
    }

    private renderFileSelector(): React.ReactNode {
        const { t } = this.props;

        return (
            <div className="col-md-6">
                <label>{translate(t, 'menu.TR_FILE')}</label>
                <div className="upload-file">
                    <input type="file"
                           className="form-control"
                           accept="application/pdf"
                           onChange={(e) => this.onUploadFile( e.target.files ? e.target.files[0] : null )}
                           disabled={false}
                           title={
                               this.state.file ?
                                   this.state.file.name :
                                   translate(t, 'menu.NOT_FILE_SELECTED')
                           }
                    />
                </div>
            </div>
        );
    }

    public onUploadFile(file: File | null): void {
        this.setState({file : file});
    }

    updateMenu(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault()
        if (this.state.file !== null && !this.state.loading) {
            this.setState({loading: true});
            this.props.updateMenu(this.state.centerId, this.state.file)
                .then(() => this.props.getMenu(this.state.centerId))
                .then(() => {this.setState({loading: false})});
        }
    }

    private renderUpdateMenuButton() {
        const { t } = this.props;

        return (
            <div className="row">
                <div className="col">
                    <Button
                        type="submit"
                        className="btn mt-4"
                        content={translate(t, 'menu.TR_SUBMIT')}
                    />
                </div>
            </div>
        )
    }

    private renderMessageCard() {
        if(this.props.updateMenuResponse?.error === null || this.state.loading) {
            return null;
        }

        return this.renderMessage(this.props.updateMenuResponse?.error, {color: "red"});
    }

    private renderMessage(message:string|undefined, style:{} = {}) {
        return (
            message ? 
                <div className="col-md-12">
                    <div className="card shadow p-3">
                        <div className="card-body">
                            <div className="message">
                                <label style={style}>{message}</label>
                            </div>
                        </div>
                    </div>
                </div>
            : null
        );
    }

    private renderPdf() {
        const { t } = this.props;

        return (
            this.props.getMenuResponse?.pdfBytes ?
                <div className="column">
                    <h6>{translate(t, 'menu.TR_CURRENT_MENU')}</h6>
                    <Document file={{data: this.props.getMenuResponse.pdfBytes}}>
                        <Page pageIndex={0} />
                    </Document> 
                </div>
            : 
            this.props.getMenuResponse && (this.state.centerId || this.props.user?.data.roles.includes(Role.ADMIN)) || this.props.user?.data.roles.includes(Role.SUPERADMIN) ?
                <p>{translate(t, 'menu.TR_NO_MENU')}</p>
                : null
        );
    }

    public render() {
        if(this.state.loading) {
            return <LoadingView loading={this.state.loading}/>;
        }

        return (
            <div>
                {this.renderMessageCard()}
                <div className="col-md-12">
                    <div className="card shadow p-3">
                        <div className="card-body">
                            {this.renderPdf()}
                            <form onSubmit={(e) => this.updateMenu(e)}>
                                <div className={"row"}>
                                    {this.renderFileSelector()}
                                </div>
                                {this.renderUpdateMenuButton()}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default withTranslation()(MenuView);